import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { ICompanyTitle } from '../models/models'

/** Faz-42: grup şirketlerinin tam ticari unvanları. Unvan ön yüzde sabitlenmez, sunucudan gelir. */
export class GetCompanyTitlesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'payment/getCompanyTitles',
      requesterInfo,
    })
  }

  public async getCompanyTitles(): Promise<ICompanyTitle[]> {
    return await this.getAsync<ICompanyTitle[]>()
  }
}
